import { useId } from 'react';

import './styles/section.css';

export default function Section({ title, count, action, children, className }) {
    const headingId = useId();
    return (
        <section className={['section', className].filter(Boolean).join(' ')} aria-labelledby={headingId}>
            <header className="section__header">
                <h2 id={headingId} className="section__title">
                    {title}
                    {Number.isFinite(count) && <span className="section__count">{count}</span>}
                </h2>
                {action && <div className="section__action">{action}</div>}
            </header>
            {children}
        </section>
    );
}
